<div class="flex gap-8 md:flex-row flex-col">
  <div class="px-3 py-6 flex flex-col items-center gap-2 md:w-[12.6rem] w-full card relative">
    <i
      nz-tooltip
      appHideTooltipOnScroll
      [nzTooltipTitle]="'my-forest.ringsRepresentsNumber' | translate"
      nzTooltipPlacement="right"
      class="absolute top-4 right-4"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M10.0016 1.66602C14.6047 1.66602 18.3362 5.39755 18.3362 10.0006C18.3362 14.6037 14.6047 18.3352 10.0016 18.3352C5.39853 18.3352 1.66699 14.6037 1.66699 10.0006C1.66699 5.39755 5.39853 1.66602 10.0016 1.66602ZM10.0016 2.91602C6.08888 2.91602 2.91699 6.08791 2.91699 10.0006C2.91699 13.9134 6.08888 17.0852 10.0016 17.0852C13.9144 17.0852 17.0862 13.9134 17.0862 10.0006C17.0862 6.08791 13.9144 2.91602 10.0016 2.91602ZM9.99854 8.74981C10.315 8.74964 10.5766 8.98456 10.6182 9.28964L10.624 9.37439L10.627 13.9591C10.6272 14.3042 10.3475 14.5843 10.0024 14.5845C9.68596 14.5847 9.42429 14.3497 9.38271 14.0447L9.37696 13.9599L9.37396 9.37522C9.37379 9.03006 9.65338 8.75006 9.99854 8.74981ZM10.002 5.83502C10.4616 5.83502 10.8342 6.20762 10.8342 6.66725C10.8342 7.12687 10.4616 7.49947 10.002 7.49947C9.54238 7.49947 9.16979 7.12687 9.16979 6.66725C9.16979 6.20762 9.54238 5.83502 10.002 5.83502Z"
          fill="#2C3035"
        />
      </svg>
    </i>
    <div class="size-[4rem] md:size-[5.5rem] shrink-0">
      <img src="../../../../../../assets/img/rings.svg" class="size-full object-contain" alt="" />
    </div>
    <div class="text-[#2C3035] heading-small font-bold">
      {{ user()?.rings }}
    </div>
    <div class="text-[#505760] text-[1.125rem]/[160%]">
      {{ 'my-forest.rings' | translate }}
    </div>
  </div>
  <div class="flex flex-1 p-6 card items-center">
    <!-- first step -->
    <div class="flex flex-1 flex flex-col items-center gap-2">
      <div
        class="size-[4rem]"
        [class.grayscale]="!timeline()?.timeline?.Seed"
        [class.opacity-40]="!timeline()?.timeline?.Seed"
      >
        <img class="size-full object-contain" src="../../../../../../assets/img/my-forest/steps/Seed.svg" alt="" />
      </div>
      <div class="flex gap-1 w-full items-center">
        <div class="bg-transparent flex-1 h-[0.2rem]"></div>
        <div class="rounded-full size-2" [class]="timeline()?.timeline?.Seed ? 'bg-[#007DCB]' : 'bg-[#D9D9D9]'"></div>
        <div class="flex-1 h-[0.2rem]" [class]="timeline()?.timeline?.Seed ? 'bg-[#007DCB]' : 'bg-[#D9D9D9]'"></div>
      </div>
      <div class="flex flex-col items-center">
        <div class="text-[0.9375rem]/[160%]" [class]="timeline()?.timeline?.Seed ? 'text-[#2C3035]' : 'text-[#D9D9D9]'">
          {{ 'my-forest.seed' | translate }}
        </div>
        <div
          class="text-[0.9375rem]/[160%] font-light"
          [class]="timeline()?.timeline?.Seed ? 'text-[#2C3035]' : 'text-[#D9D9D9]'"
        >
          {{ timeline()?.timeline?.Seed ? (timeline().timeline.Seed | date: 'dd MMM yyyy') : '-' }}
        </div>
      </div>
    </div>
    <!-- second step -->
    <div class="flex flex-1 flex flex-col items-center gap-2">
      <div
        class="size-[4rem]"
        [class.grayscale]="!timeline()?.timeline?.Ganacuate"
        [class.opacity-40]="!timeline()?.timeline?.Ganacuate"
      >
        <img class="size-full object-contain" src="../../../../../../assets/img/my-forest/seed.svg" alt="" />
      </div>
      <div class="flex gap-1 w-full items-center">
        <div
          class="flex-1 h-[0.2rem]"
          [class]="timeline()?.timeline?.Ganacuate ? 'bg-[#007DCB]' : 'bg-[#D9D9D9]'"
        ></div>
        <div
          class="rounded-full size-2"
          [class]="timeline()?.timeline?.Ganacuate ? 'bg-[#007DCB]' : 'bg-[#D9D9D9]'"
        ></div>
        <div
          class="flex-1 h-[0.2rem]"
          [class]="timeline()?.timeline?.Ganacuate ? 'bg-[#007DCB]' : 'bg-[#D9D9D9]'"
        ></div>
      </div>
      <div class="flex flex-col items-center">
        <div
          class="text-[0.9375rem]/[160%]"
          [class]="timeline()?.timeline?.Ganacuate ? 'text-[#2C3035]' : 'text-[#D9D9D9]'"
        >
          {{ 'my-forest.ganacuate' | translate }}
        </div>
        <div
          class="text-[0.9375rem]/[160%] font-light"
          [class]="timeline()?.timeline?.Ganacuate ? 'text-[#2C3035]' : 'text-[#D9D9D9]'"
        >
          {{ timeline()?.timeline?.Ganacuate ? (timeline().timeline.Ganacuate | date: 'dd MMM yyyy') : '-' }}
        </div>
      </div>
    </div>
    <!-- last step -->
    <div class="flex flex-1 flex flex-col items-center gap-2">
      <div
        class="size-[4rem]"
        [class.grayscale]="!timeline()?.timeline?.Ganarbol"
        [class.opacity-40]="!timeline()?.timeline?.Ganarbol"
      >
        <img class="size-full object-contain" src="../../../../../../assets/img/my-forest/ganarbol.svg" alt="" />
      </div>
      <div class="flex gap-1 w-full items-center">
        <div class="flex-1 h-[0.2rem]" [class]="timeline()?.timeline?.Ganarbol ? 'bg-[#007DCB]' : 'bg-[#D9D9D9]'"></div>
        <div
          class="rounded-full size-2"
          [class]="timeline()?.timeline?.Ganarbol ? 'bg-[#007DCB]' : 'bg-[#D9D9D9]'"
        ></div>
        <div class="bg-transparent flex-1 h-[0.2rem]"></div>
      </div>
      <div class="flex flex-col items-center">
        <div
          class="text-[0.9375rem]/[160%]"
          [class]="timeline()?.timeline?.Ganarbol ? 'text-[#2C3035]' : 'text-[#D9D9D9]'"
        >
          {{ 'my-forest.ganarbol' | translate }}
        </div>
        <div
          class="text-[0.9375rem]/[160%] font-light"
          [class]="timeline()?.timeline?.Ganarbol ? 'text-[#2C3035]' : 'text-[#D9D9D9]'"
        >
          {{ timeline()?.timeline?.Ganarbol ? (timeline().timeline.Ganarbol | date: 'dd MMM yyyy') : '-' }}
        </div>
      </div>
    </div>
  </div>
</div>
